"use client";


import { motion } from "framer-motion";


// IMAGES (replace with your actual Sinharaja images)
import sinharajaHero from "../../accests/sinharaja/sinha (1).jpeg";
import flora from "../../accests/sinharaja/sinha (2).jpeg";
import birds from "../../accests/sinharaja/sinha (3).jpeg";
import trek from "../../accests/sinharaja/sinha (4).jpeg";
import rock from "../../accests/sinharaja/sinha (5).jpeg";
import mal from "../../accests/sinharaja/birds.jpeg";


export default function SinharajaRainforestTrek() {

    const highlights = [
        {
            title: "Wildlife Encounters",
            desc: "Experience close-up interactions with rare birds, butterflies, reptiles, and endemic wildlife found only in Sri Lanka.",
            img: birds
        },
        {
            title: "Endemic Flora & Fauna",
            desc: "Discover unique plant species and ancient trees that make Sinharaja one of the world’s most biodiverse rainforests.",
            img: mal
        },
        {
            title: "Guided Rainforest Trek",
            desc: "Trek deep into the tropical wilderness with an experienced English-speaking guide sharing expert insights.",
            img: trek
        },

        // {
        //     title: "Village Nature Walk",
        //     desc: "Explore nearby villages bordering the rainforest and experience local life connected to nature.",
        //     img: village
        // }
    ];

    const itinerary = [
        "Early morning pickup from your hotel",
        "Arrival at Sinharaja Rainforest Reserve",
        "Guided rainforest trek with nature interpretation",
        "Wildlife and birdwatching experience",
        "Visit Sinhagala Rock viewpoint",
        "Afternoon village trek near the forest boundary",
        "Relaxation and refreshment break",
        "Return journey to your hotel"
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO SECTION */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative h-[60vh]"
            >
                <img
                    src={sinharajaHero}
                    alt="Sinharaja Rainforest Trek"
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Sinharaja Rainforest Trek
                    </motion.h1>
                    <motion.p
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.6 }}
                        className="mt-4 max-w-2xl text-lg drop-shadow-md"
                    >
                        An unforgettable adventure in Sri Lanka’s tropical wilderness.
                    </motion.p>
                </div>
            </motion.div>

            {/* TOUR HIGHLIGHTS */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="max-w-7xl mx-auto px-6 py-16">
                <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                    Trek Highlights
                </h2>

                <div className="grid md:grid-cols-3 gap-8">
                    {highlights.map((item, index) => (
                        <motion.div
                            key={index}
                            whileHover={{ scale: 1.05 }}
                            className="bg-white rounded-3xl shadow-lg overflow-hidden"
                        >
                            <img
                                src={item.img}
                                alt={item.title}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-6">
                                <h3 className="text-xl font-semibold text-green-600 mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-gray-600 text-sm">
                                    {item.desc}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* ITINERARY */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-100 py-16">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">

                    <div>
                        <h2 className="text-3xl font-bold mb-10 text-gray-800">
                            Detailed Itinerary
                        </h2>

                        <ul className="space-y-4 text-gray-700 list-decimal list-inside">
                            {itinerary.map((step, index) => (
                                <motion.li
                                    key={index}
                                    initial={{ x: -50, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    className="text-lg"
                                >
                                    {step}
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    {/* IMAGE GRID */}
                    <div className="grid grid-cols-2 gap-4">
                        {[flora, birds, rock,sinharajaHero].map((img, i) => (
                            <motion.img
                                key={i}
                                src={img}
                                alt="Sinharaja Trek"
                                whileHover={{ scale: 1.05 }}
                                className="h-40 w-full object-cover rounded-2xl shadow-lg"
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/*  WHY CHOOSE THIS TREK */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="relative py-24 overflow-hidden">

                <div className="absolute inset-0">
                    <img
                        src={sinharajaHero}
                        alt="Why Sinharaja"
                        className="w-full h-full object-cover scale-110 blur-md"
                    />
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                <div className="relative max-w-6xl mx-auto px-6 text-white text-center">

                    <h2 className="text-3xl md:text-4xl font-bold mb-10">
                        Why Choose This Trek?
                    </h2>

                    <ul className="max-w-3xl mx-auto space-y-4 text-lg list-disc list-inside backdrop-blur-md bg-white/10 p-8 rounded-3xl shadow-xl">
                        <li>Trek through a UNESCO World Heritage Site.</li>
                        <li>Encounter rare and endemic wildlife species.</li>
                        <li>Led by an experienced English-speaking guide.</li>
                        <li>Perfect for nature lovers and wildlife enthusiasts.</li>
                        <li>A true off-the-beaten-path rainforest adventure.</li>
                    </ul>
                    {/* CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="mt-14"
                    >
                        <motion.a
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Sinharaja%20Rainforest%20Trek"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-14 py-4
        bg-green-500 text-white font-semibold text-lg
        rounded-full shadow-xl hover:bg-green-400
        transition-all duration-300"
                        >
                            Book Sinharaja Rainforest Trek
                        </motion.a>

                        <p className="mt-4 text-sm text-gray-200">
                            🥾 Guided Trek • 🌿 Nature Experience • 📸 Wildlife Photography
                        </p>
                    </motion.div>


                </div>
            </section>

        </div>
    );
}
